let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lbhrA")).then(() => parcelRequire('3wXGb'));